export const FILE_TYPE = {
  XLSX: 'xlsx',
  XLS: 'xls',
  CSV: 'csv',
  DOCX: 'docx',
  PDF: 'pdf',
  JSON: 'json',
};
